import { render, staticRenderFns } from "./MemberViewMemberInfoCard.vue?vue&type=template&id=0b1d5c08"
import script from "./MemberViewMemberInfoCard.vue?vue&type=script&lang=js"
export * from "./MemberViewMemberInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports